export default __webpack_public_path__ + "static/media/qr.9747791f.jpeg";